const configs = {
  artyou: {
    common: {
      BRAND_NAME: 'Artyou',
      // BRAND_COLOR: '#FF6B6B',
      LOGO_URL: '/images/artyou/logo.png',
      HOME_IMAGE: '/images/artyou/home.jpg',
      COMMUNICATION_IMAGE: '/images/artyou/communication.jpg',
      MAX_AVATAR_SIZE: 524288,
      CONTACT_EMAIL: 'info@artyouroma.it',
      CONTACT_PHONE: '+39 327 18 81 956',
      WITH_WALLS: false,
      WITH_RESERVATION: false,
      WITH_COURSE_MATERIALS: false,
      USE_PAYPAL: false,
      USE_STRIPE: true,
      USE_CASH_MEMBERSHIP: false,
      USE_GOOGLE: false,
      USE_CUSTOM_AMOUNT: true,
      WITH_EXPENSES: true,
      WITH_PAYMENT_NOTES: true,
      WITH_USER_AND_TEACHER_DETAILS: true,
      WITH_SUSPENDED_ENROLLMENTS: true,
      SHOW_PAYMENT_DETAILS_TEACHER_COURSE: true,
      SHOW_PAYMENT_DETAILS_TEACHER_COURSE_GRID: true,
      CAN_CREATE_USER: false,
    },
    development: {
      SERVER_URL: 'http://localhost:5555',
      SHOW_TUTORIAL: true,
      SHOW_ENROLLMENTS_TEACHER_PAGE: true,
      PAYPAL_CLIENT_ID: 'AX_gDJDrK3xwIUBLiq80yD9EKDDbGbZ3fis_xrqyRkloeYMcwBVil5DhYvk7Is3K_iMYixHimVPDzyXq',
    },
    staging: {
      SERVER_URL: 'https://artyou.staging.infinitymundi.it',
      SHOW_TUTORIAL: true,
      SHOW_ENROLLMENTS_TEACHER_PAGE: true,
      PAYPAL_CLIENT_ID: 'AX_gDJDrK3xwIUBLiq80yD9EKDDbGbZ3fis_xrqyRkloeYMcwBVil5DhYvk7Is3K_iMYixHimVPDzyXq',
    },
    production: {
      SERVER_URL: 'https://artyou.infinitymundi.it',
      SHOW_TUTORIAL: true,
      SHOW_ENROLLMENTS_TEACHER_PAGE: true,
      PAYPAL_CLIENT_ID: 'xxxxx',
    },
  },
  assettoteatro: {
    common: {
      BRAND_NAME: 'Assetto Teatro',
      // BRAND_COLOR: '#2b3c36',
      LOGO_URL: '/images/assettoteatro/logo.png',
      HOME_IMAGE: '/images/assettoteatro/home.jpg',
      COMMUNICATION_IMAGE: '/images/assettoteatro/communication.jpg',
      MAX_AVATAR_SIZE: 524288,
      CONTACT_EMAIL: 'assettoteatro@gmail.com',
      CONTACT_PHONE: '+39 366 4454753',
      WITH_WALLS: false,
      WITH_RESERVATION: false,
      WITH_COURSE_MATERIALS: true,
      USE_CUSTOM_AMOUNT: true,
      USE_STRIPE: false,
      USE_PAYPAL: false,
      USE_CASH_MEMBERSHIP: true,
      USE_GOOGLE: true,
      WITH_EXPENSES: false,
      WITH_PAYMENT_NOTES: false,
      WITH_USER_AND_TEACHER_DETAILS: false,
      WITH_SUSPENDED_ENROLLMENTS: false,
      SHOW_PAYMENT_DETAILS_TEACHER_COURSE: false,
      SHOW_PAYMENT_DETAILS_TEACHER_COURSE_GRID: true,
      CAN_CREATE_USER: true,
    },
    development: {
      SERVER_URL: 'http://localhost:5555',
      // SERVER_URL: 'http://192.168.1.2:5555',
      SHOW_TUTORIAL: true,
      SHOW_ENROLLMENTS_TEACHER_PAGE: false, // mostra la pagina iscrizioni nella teacher page
      PAYPAL_CLIENT_ID: 'AX_gDJDrK3xwIUBLiq80yD9EKDDbGbZ3fis_xrqyRkloeYMcwBVil5DhYvk7Is3K_iMYixHimVPDzyXq', // giggioz associate paypal
    },
    staging: {
      SERVER_URL: 'https://assettoteatro.staging.infinitymundi.it',
      SHOW_TUTORIAL: true,
      SHOW_ENROLLMENTS_TEACHER_PAGE: false,
      PAYPAL_CLIENT_ID: 'AX_gDJDrK3xwIUBLiq80yD9EKDDbGbZ3fis_xrqyRkloeYMcwBVil5DhYvk7Is3K_iMYixHimVPDzyXq',
    },
    production: {
      SERVER_URL: 'https://assettoteatro.infinitymundi.it',
      SHOW_TUTORIAL: false,
      SHOW_ENROLLMENTS_TEACHER_PAGE: false,
      PAYPAL_CLIENT_ID: 'AYB-zWhiJcgRHlB5iYYbn6cyluHbInz0VODRdd9n8IwAxi5YLLjNKlvhHt_Ij0PxgwOQlmMUzqSnS0RO',
    },
  },
  darsena: {
    common: {
      BRAND_NAME: 'Darsena',
      // BRAND_COLOR: '#45B7D1',
      LOGO_URL: '/images/darsena/logo.png',
      HOME_IMAGE: '/images/darsena/home.jpg',
      COMMUNICATION_IMAGE: '/images/darsena/communication.jpg',
      MAX_AVATAR_SIZE: 524288,
      CONTACT_EMAIL: 'info@darsena.it',
      CONTACT_PHONE: '+39 0123 456789',
      WITH_WALLS: false,
      WITH_RESERVATION: false,
      WITH_COURSE_MATERIALS: true,
      USE_PAYPAL: false,
      USE_STRIPE: true,
      USE_CASH_MEMBERSHIP: true,
      USE_GOOGLE: false,
      USE_CUSTOM_AMOUNT: false,
      WITH_EXPENSES: false,
      WITH_PAYMENT_NOTES: false,
      WITH_USER_AND_TEACHER_DETAILS: true,
      WITH_SUSPENDED_ENROLLMENTS: false,
      SHOW_PAYMENT_DETAILS_TEACHER_COURSE: true,
      SHOW_PAYMENT_DETAILS_TEACHER_COURSE_GRID: true,
      CAN_CREATE_USER: false,
    },
    development: {
      SERVER_URL: 'http://localhost:5555',
      SHOW_TUTORIAL: true,
      SHOW_ENROLLMENTS_TEACHER_PAGE: true,
      PAYPAL_CLIENT_ID: 'AR9DDzTjQ35E9_iUNaMQTcjPbIIT0oCHGkwRqgkKNf9Rpx-pCYHyZJBbNjqkUXrRW3R0VRuz60jyQGeM',
    },
    production: {
      SERVER_URL: 'http://217.154.113.14:3334',
      SHOW_TUTORIAL: true,
      SHOW_ENROLLMENTS_TEACHER_PAGE: true,
      PAYPAL_CLIENT_ID: 'AR9DDzTjQ35E9_iUNaMQTcjPbIIT0oCHGkwRqgkKNf9Rpx-pCYHyZJBbNjqkUXrRW3R0VRuz60jyQGeM',
    },
    staging: {
      SERVER_URL: 'http://217.154.113.14:3335',
      SHOW_TUTORIAL: true,
      SHOW_ENROLLMENTS_TEACHER_PAGE: true,
      PAYPAL_CLIENT_ID: 'AR9DDzTjQ35E9_iUNaMQTcjPbIIT0oCHGkwRqgkKNf9Rpx-pCYHyZJBbNjqkUXrRW3R0VRuz60jyQGeM',
    },
  },
  rockdreams: {
    common: {
      BRAND_NAME: 'Rock Dreams',
      // BRAND_COLOR: '#2b3c36',
      LOGO_URL: '/images/rockdreams/logo.png',
      HOME_IMAGE: '/images/rockdreams/home.jpg',
      COMMUNICATION_IMAGE: '/images/rockdreams/communication.jpg',
      MAX_AVATAR_SIZE: 524288,
      CONTACT_EMAIL: 'info@rockdreams.it',
      CONTACT_PHONE: '+39 366 4454753',
      WITH_WALLS: true,
      WITH_RESERVATION: true,
      WITH_COURSE_MATERIALS: true,
      USE_PAYPAL: false,
      USE_STRIPE: true,
      USE_CASH_MEMBERSHIP: true,
      USE_GOOGLE: false,
      USE_CUSTOM_AMOUNT: true,
      SHOW_PAYMENT_DETAILS_TEACHER_COURSE: true,
      SHOW_PAYMENT_DETAILS_TEACHER_COURSE_GRID: true,
      WITH_EXPENSES: true,
      WITH_PAYMENT_NOTES: true,
      WITH_USER_AND_TEACHER_DETAILS: true,
      WITH_SUSPENDED_ENROLLMENTS: true,
      CAN_CREATE_USER: false,
    },
    development: {
      SERVER_URL: 'http://localhost:5555',
      SHOW_TUTORIAL: false,
      SHOW_ENROLLMENTS_TEACHER_PAGE: false, // mostra la pagina iscrizioni nella teacher page
      PAYPAL_CLIENT_ID: 'AX_gDJDrK3xwIUBLiq80yD9EKDDbGbZ3fis_xrqyRkloeYMcwBVil5DhYvk7Is3K_iMYixHimVPDzyXq', // giggioz associate paypal
    },
    staging: {
      SERVER_URL: 'https://rockdreams.staging.infinitymundi.it',
      SHOW_TUTORIAL: false,
      SHOW_ENROLLMENTS_TEACHER_PAGE: false,
      PAYPAL_CLIENT_ID: 'xxx',
    },
    production: {
      SERVER_URL: 'https://rockdreams.infinitymundi.it',
      SHOW_TUTORIAL: false,
      SHOW_ENROLLMENTS_TEACHER_PAGE: false,
      PAYPAL_CLIENT_ID: 'xxxxxx',
    },
  },
};

const getConfig = () => {
  const associate = process.env.REACT_APP_ASSOCIATE;
  const environment = process.env.REACT_APP_ENVIRONMENT;

  // Validazione dell'ambiente
  const validEnvironments = ['development', 'production', 'staging'];
  if (!validEnvironments.includes(environment)) {
    throw new Error(`Ambiente non valido: ${environment}. Ambienti validi: ${validEnvironments.join(', ')}`);
  }

  if (!associate || !configs[associate] || !configs[associate][environment]) {
    throw new Error(`Config non trovata per cliente ${associate} e ambiente ${environment}`);
  }

  // Unisce le proprietà common con quelle specifiche dell'ambiente
  const commonConfig = configs[associate].common || {};
  const environmentConfig = configs[associate][environment];
  
  return {
    ASSOCIATE: associate,
    ...commonConfig,
    ...environmentConfig
  };
};

export default getConfig;
